import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Anchor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M10 3.5C10 4.33934 9.48296 5.05793 8.75 5.35462V6H10V7.5H8.75V13.184C10.5786 12.8585 12.0025 11.3635 12.2209 9.5H11.5V8H15V9.5H13.7286C13.4752 12.4415 11.0072 14.75 8 14.75C4.99282 14.75 2.52481 12.4415 2.27144 9.5H1V8H4.5V9.5H3.7791C3.99749 11.3635 5.42142 12.8585 7.25 13.184V7.5H6V6H7.25V5.35462C6.51704 5.05793 6 4.33934 6 3.5C6 2.39543 6.89543 1.5 8 1.5C9.10457 1.5 10 2.39543 10 3.5ZM8.5 3.5C8.5 3.77614 8.27614 4 8 4C7.72386 4 7.5 3.77614 7.5 3.5C7.5 3.22386 7.72386 3 8 3C8.27614 3 8.5 3.22386 8.5 3.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Anchor;
